module.exports = __webpack_public_path__ + "static/img/gongsishouye_14.720deeca.jpg";